import { useApiClient } from '@/hooks/useApiClient'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useProducts = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const apiClient = useApiClient()

  const useProductNamesQuery = () =>
    useQuery({
      queryKey: ['productNamesQuery'],
      queryFn: ({ queryKey }) => api.post('product/names'),
      refetchOnWindowFocus: false,
    })

  const useAllProductsQuery = () => apiClient.useQuery('post', '/product/all')

  return { useProductNamesQuery, useAllProductsQuery }
}
